<template>
    <div class="bodymsg-box">
        <div class="flex flex-y-center mb-56">
            <div class="progress-tit">档案完成度{{ bodyRate }}%</div>
            <van-progress class="progress" stroke-width="10px" color="#2FD0D5" :show-pivot="false" :percentage="bodyRate" />
        </div>
        <div class="mb-20" v-for="(item, index) in bodyData" :key="index">
            <van-collapse v-model="activeNames" :border="false">
                <van-collapse-item :title="item.title" :name="index" :border="false">
                    <!-- 题目类型 0 选项需要输入框 1单选 2 多选 3 文本 -->
                    <!-- 类型 0 菜单 1 问题 2选项 -->
                    <!-- 第一层标题 -->
                    <div v-for="(two, oIndex) in item.children" :key="oIndex">
                        <div class="line flex flex-y-center" v-if="item.children && item.menuType == 0">
                            <div :class="`circle ${two.check ? 'already' : ''}`"></div>
                            <div class="msg-tit">{{ two.title }}：</div>
                        </div>
                        <!-- 第一层内选项 -->
                        <div class="options-box" v-if="two.children && two.menuType == 1 && two.itemType == 1">
                            <van-radio-group v-model="two.value" @change="onDataChange" direction="horizontal">
                                <div v-for="(options, optionIndex) in two.children" :key="optionIndex">
                                    <van-radio :name="options.id" checked-color="#2fd0d5">{{ options.title }}
                                    </van-radio>
                                    <input v-if="options.itemType == 0" v-model="options.value" @input="onDataChange" type="text" class="input-short" />
                                </div>
                            </van-radio-group>
                        </div>
                        <div class="options-box" v-if="two.children && two.menuType == 1 && two.itemType == 2">
                            <van-checkbox-group v-model="two.value" @change="onDataChange" direction="horizontal">
                                <div v-for="(options, optionIndex) in two.children" :key="optionIndex + 1">
                                    <van-checkbox :name="options.id" checked-color="#2fd0d5" shape="square">
                                        {{ options.title }}
                                    </van-checkbox>
                                    <input v-if="options.itemType == 0" v-model="options.value" @input="onDataChange" type="text" class="input-short" />
                                </div>
                            </van-checkbox-group>
                        </div>
                        <div class="options-box" v-if="two.menuType == 1 && two.itemType == 3">
                            <input v-model="two.value" @input="onDataChange" type="text" class="input-long" />
                        </div>

                        <!-- 第二层标题 -->
                        <div v-for="(three, threeIndex) in two.children" :key="threeIndex + 2">
                            <div class="line-inner flex flex-y-center" v-if="two.children && two.menuType == 0">
                                <div :class="`circle ${three.check ? 'already' : ''}`"></div>
                                <div class="msg-tit">{{ three.title }}：</div>
                            </div>
                            <!-- 第二层内选项 -->
                            <div class="options-box" v-if="
                                three.children && three.menuType == 1 && three.itemType == 1
                            ">
                                <van-radio-group v-model="three.value" @change="onDataChange" direction="horizontal">
                                    <div v-for="(options, optionIndex) in three.children" :key="optionIndex">
                                        <van-radio :name="options.id" checked-color="#2fd0d5">{{ options.title }}
                                        </van-radio>
                                        <input v-if="options.itemType == 0" v-model="options.value" @input="onDataChange" type="text" class="input-short" />
                                    </div>
                                </van-radio-group>
                            </div>
                            <div class="options-box" v-if="
                                three.children && three.menuType == 1 && three.itemType == 2
                            ">
                                <van-checkbox-group v-model="three.value" @change="onDataChange" direction="horizontal">
                                    <div v-for="(options, optionIndex) in three.children" :key="optionIndex">
                                        <van-checkbox :name="options.id" checked-color="#2fd0d5" shape="square">
                                            {{ options.title }}
                                        </van-checkbox>
                                        <input v-if="options.itemType == 0" v-model="options.value" @input="onDataChange" type="text" class="input-short" />
                                    </div>
                                </van-checkbox-group>
                            </div>
                            <div class="options-box" v-if="three.menuType == 1 && three.itemType == 3">
                                <input v-model="three.value" type="text" @input="onDataChange" class="input-long" />
                            </div>
                        </div>
                    </div>
                </van-collapse-item>
            </van-collapse>
        </div>
        <div class="flex flex-x-center">
            <button class="save-btn" @click="saveBody">保存</button>
        </div>
    </div>
</template>

<script>
    import { checkCircle } from "./config.js";
    export default {
        props: {
            bodyData: {
                type: Array,
                default: function () {
                    return [];
                },
            },
            bodyRate: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                activeNames: [0],
                activeNames1: ["1"],
                radio: "1",
                result: ["a", "b"],
                rate: "",
            };
        },
        mounted() {
            this.onDataChange();
        },
        methods: {
            saveBody() {
                this.$emit("onBodySave", this.bodyData);
            },
            onDataChange() {
                this.bodyData = checkCircle(this.bodyData);
            },
        },
    };
</script>

<style lang="less" scoped>
    .mb-56 {
        margin-bottom: 56px;
    }

    .mt-50 {
        margin-top: 50px !important;
    }

    .bodymsg-box {
        width: 100%;
        padding: 30px 30px;
    }

    .progress-tit {
        min-width: 158px;
        font-size: 24px;
        color: #2fd0d5;
        margin-right: 20px;
    }

    .progress {
        flex: 1;
    }

    .line {
        margin-top: 40px;
        margin-bottom: 40px;
    }

    .line-inner {
        padding: 0 35px;
        margin-bottom: 14px;
    }

    .circle {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        margin-right: 22px;
        background: #d8d8d8;
    }

    .circle.already {
        background: #333f48;
    }

    .msg-tit {
        min-width: 158px;
        font-size: 28px;
        color: #35434c;
    }

    .options-box {
        padding: 0 0 0 170px;
    }

    .input-short {
        width: 448px;
        border: none;
        border-bottom: 1px solid #999999;
        margin-left: 50px;
        margin-bottom: 40px;
        color: #35434c;
    }

    .input-long {
        width: 500px;
        border: none;
        border-bottom: 1px solid #999999;
        color: #35434c;
        margin-bottom: 70px;
    }

    .save-btn {
        width: 520px !important;
        height: 90px;
        background: #333f48;
        border-radius: 45px;
        color: #ffffff;
        font-size: 30px;
        line-height: 90px;
        padding: 0;
        margin-top: 50px;
        overflow: hidden;
        margin-bottom: 55px;
    }

    :deep(input:disabled, input[disabled]) {
        color: #333f48;
        opacity: 1;
        -webkit-text-fill-color: #333f48; // ios 和 安卓9.0 必须添加此属性，才会生效
        -webkit-opacity: 1;
        background-color: transparent;
    }
</style>
